// 注意不要修改此文件，此文件由 scripts/tools/index.js 生成
import config from './saas/index';
export default config;
